import Konva from "konva";

export class SelectionBox {

    private stage: Konva.Stage;
    private layer: Konva.Layer;
    private selectionRectangle: Konva.Rect;
    private selectionStart: { x: number, y: number };
    private isSelecting: boolean;
  
    constructor(stage: Konva.Stage, layer: Konva.Layer) {
      this.stage = stage;
      this.layer = layer;
  
      this.selectionRectangle = new Konva.Rect({
        fill: 'rgba(0, 0, 255, 0.1)',
        stroke: 'rgba(0, 0, 255, 0.3)',
        dash: [2,1],
        strokeScaleEnabled: false,
        visible: false,
      });
      this.layer.add(this.selectionRectangle);
  
      this.selectionStart = { x: 0, y: 0 };
      this.isSelecting = false;
  
      this.initialize();
    }

    private getRelativePointerPosition(): { x: number, y: number } | null {
        const pos = this.stage.getPointerPosition();
        if (pos) {
          const transform = this.stage.getAbsoluteTransform().copy();
          transform.invert();
          const point = transform.point(pos);
          return point;
        }
        return null;
      }
  
    private initialize(): void {
      this.stage.on('mousedown touchstart', (e) => {

        // do nothing if we mousedown on any shape
        if (e.target !== this.stage) {
            return;
        }
        e.evt.preventDefault();

        if (e.evt.button === 0)  {
            const pointerPosition = this.getRelativePointerPosition();
            
            if (pointerPosition) {
                this.isSelecting = true;
                this.selectionStart = { x: pointerPosition.x, y: pointerPosition.y};
                this.selectionRectangle.visible(true);
                this.selectionRectangle.width(0);
                this.selectionRectangle.height(0);
                this.selectionRectangle.position(this.selectionStart);
            }
        }
      });
  
      this.stage.on('mousemove touchmove', (e) => {

        // do nothing if we didn't start selection
        if (!this.isSelecting) {
            return;
        }
        e.evt.preventDefault();
        
        const pointerPosition = this.getRelativePointerPosition();
        if (pointerPosition) {
          const width = (pointerPosition.x) - this.selectionStart.x;
          const height = (pointerPosition.y) - this.selectionStart.y;

          this.selectionRectangle.width(Math.abs(width));
          this.selectionRectangle.height(Math.abs(height));
          this.selectionRectangle.position({
            x: width < 0 ? (pointerPosition.x) : this.selectionStart.x,
            y: height < 0 ? (pointerPosition.y) : this.selectionStart.y
          });
        }
      });
  
      this.stage.on('mouseup touchend', (e) => {
         // do nothing if we didn't start selection
         this.isSelecting = false;
         if (!this.selectionRectangle.visible()) {
           return;
         }
         e.evt.preventDefault();
         // update visibility in timeout, so we can check it in click event
         this.selectionRectangle.visible(false);
         var shapes = this.stage.find('.rect');
         var box = this.selectionRectangle.getClientRect();
         var selected = shapes.filter((shape) =>
           Konva.Util.haveIntersection(box, shape.getClientRect())
         );
         //tr.nodes(selected);
      });
    }
  }